import React from 'react';
import { InvoiceGroupedSummaryRow } from '@/services/api/invoice';

interface Props {
  rows: InvoiceGroupedSummaryRow[];
}

const formatRupiah = (n: number): string =>
  'Rp ' + n.toLocaleString('id-ID');

const InvoiceGroupedSummary: React.FC<Props> = ({ rows }) => {
  if (rows.length === 0) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden mb-6">
      <div className="px-4 py-3 border-b border-gray-100 flex items-center gap-2">
        <span className="font-semibold text-sm text-gray-700">Summary by model</span>
        <span className="text-xs text-gray-400 bg-gray-100 rounded px-2 py-0.5">
          display only
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wide">
                Model
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wide">
                Active Days
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wide">
                Vehicles
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wide">
                Rate/Day
              </th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wide">
                Subtotal
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((row, i) => (
              <tr key={i} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium text-gray-900">{row.modelName}</td>
                <td className="px-4 py-3 text-right text-gray-600">{row.activeDays}</td>
                <td className="px-4 py-3 text-right text-gray-600">{row.vehicleCount}</td>
                <td className="px-4 py-3 text-right text-gray-600">
                  {formatRupiah(row.dailyRate)}
                </td>
                <td className="px-4 py-3 text-right font-medium text-gray-900">
                  {formatRupiah(row.subtotal)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceGroupedSummary;
